import { createAsyncAction, createAction } from 'typesafe-actions';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { webApiGet, webApiPost, webApiMultipartPost } from '../../api/client'
import { SupplierProductMapping } from '../../api/models/SupplierProductMapping';
import { SupplierDeliveryTime } from '../../api/models/SupplierDeliveryTime';
import { Supplier } from '../../api/models/QuotedData';
import { UpdateCatalogueOptionFilled } from '../components/UpdateCatalogueRequest';
import { SupplierOrders } from '../apiModels';


export const getSupplierInfoAsync = createAsyncAction(
    "GET_SUPPLIER_INFO_REQUEST",
    "GET_SUPPLIER_INFO_SUCCESS",
    "GET_SUPPLIER_INFO_ERROR")<undefined, Supplier, Error>()


export const getSupplierInfoAsyncThunk = (supplierId?: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getSupplierInfoAsync.request())
            return webApiGet('/auth/info/supplier',
                (data: Supplier) => { dispatch(getSupplierInfoAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getSupplierInfoAsync.failure(err)); },
                null,
                3
            )
        })
    }
}

export const getSupplierProductsMappingsAsync = createAsyncAction(
    "GET_SUPPLIER_PRODUCTS_MAPPINGS_REQUEST",
    "GET_SUPPLIER_PRODUCTS_MAPPINGS_SUCCESS",
    "GET_SUPPLIER_PRODUCTS_MAPPINGS_ERROR")<undefined, SupplierProductMapping[], Error>()


export const getSupplierProductsMappingsAsyncThunk = (supplierId?: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getSupplierProductsMappingsAsync.request())
            return webApiGet('/supplysystem/mappings',
                (data: SupplierProductMapping[]) => { dispatch(getSupplierProductsMappingsAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getSupplierProductsMappingsAsync.failure(err)); },
                null,
                3
            )
        })
    }
}

export const updateSupplierProductsMappingsAsync = createAsyncAction(
    "UPDATE_SUPPLIER_PRODUCTS_MAPPINGS_REQUEST",
    "UPDATE_SUPPLIER_PRODUCTS_MAPPINGS_SUCCESS",
    "UPDATE_SUPPLIER_PRODUCTS_MAPPINGS_ERROR")<undefined, SupplierProductMapping[], Error>()


export const updateSupplierProductsMappingsAsyncThunk = (supplierProductsMappings: SupplierProductMapping[]): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(updateSupplierProductsMappingsAsync.request())
            return webApiPost('/supplysystem/mappings',
                supplierProductsMappings,
                () => { dispatch(updateSupplierProductsMappingsAsync.success(supplierProductsMappings)); resolve() },
                (err: Error) => { dispatch(updateSupplierProductsMappingsAsync.failure(err)); }
            )
        })
    }
}



export const sendSupplierOfferFileAsync = createAsyncAction(
    "SEND_SUPPLIER_OFFER_FILE_REQUEST",
    "SEND_SUPPLIER_OFFER_FILE_SUCCESS",
    "SEND_SUPPLIER_OFFER_FILE_ERROR")<undefined, void, Error>()


export const sendSupplierOfferFileAsyncThunk = (files: File): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(sendSupplierOfferFileAsync.request())

            webApiMultipartPost('/offer/supplier/file',
                files,
                () => { dispatch(sendSupplierOfferFileAsync.success()); resolve() },
                (err: Error) => { dispatch(sendSupplierOfferFileAsync.failure(err)); resolve() }
            )
        })
    }
}


export const updateSupplierDeliveryTimesAsync = createAsyncAction(
    "UPDATE_SUPPLIER_DELIVERY_TIMES_REQUEST",
    "UPDATE_SUPPLIER_DELIVERY_TIMES_SUCCESS",
    "UPDATE_SUPPLIER_DELIVERY_TIMES_ERROR")<undefined, SupplierDeliveryTime[], Error>()


export const updateSupplierDeliveryTimesAsyncThunk = (sdts: SupplierDeliveryTime[]): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(updateSupplierDeliveryTimesAsync.request())
            webApiPost('/supplysystem/deliveryConfig/update',
                sdts,
                (upSdts: SupplierDeliveryTime[]) => { dispatch(updateSupplierDeliveryTimesAsync.success(upSdts)); resolve() },
                (err: Error) => { dispatch(updateSupplierDeliveryTimesAsync.failure(err)); }
            )
        })
    }
}


export const removeSupplierDeliveryTimeAsync = createAsyncAction(
    "REMOVE_SUPPLIER_DELIVERY_TIME_REQUEST",
    "REMOVE_SUPPLIER_DELIVERY_TIME_SUCCESS",
    "REMOVE_SUPPLIER_DELIVERY_TIME_ERROR")<undefined, SupplierDeliveryTime[], Error>()


export const removeSupplierDeliveryTimeAsyncThunk = (sdt: SupplierDeliveryTime): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(removeSupplierDeliveryTimeAsync.request())
            webApiPost('/supplysystem/deliveryConfig/remove',
                sdt,
                (upSdts: SupplierDeliveryTime[]) => { dispatch(removeSupplierDeliveryTimeAsync.success(upSdts)); resolve() },
                (err: Error) => { dispatch(removeSupplierDeliveryTimeAsync.failure(err)); }
            )
        })
    }
}


export const sendCatalogUpdatePropositionAsync = createAsyncAction(
    "SEND_CATALOG_UPDATE_PROPOSITION_REQUEST",
    "SEND_CATALOG_UPDATE_PROPOSITION_SUCCESS",
    "SEND_CATALOG_UPDATE_PROPOSITION_ERROR")<undefined, undefined, Error>()


export const sendCatalogUpdatePropositionAsyncThunk = (request: UpdateCatalogueOptionFilled): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(sendCatalogUpdatePropositionAsync.request())
            webApiPost('/supplysystem/catalogue/proposition',
                { propositionType: request.optionId, propositionLabel: request.label, propositionText: request.text },
                () => { dispatch(sendCatalogUpdatePropositionAsync.success()); resolve() },
                (err: Error) => { dispatch(sendCatalogUpdatePropositionAsync.failure(err)); }
            )
        })
    }
}


export const getSupplierOrdersAsync = createAsyncAction(
    "GET_SUPPLIER_ORDERS_REQUEST",
    "GET_SUPPLIER_ORDERS_SUCCESS",
    "GET_SUPPLIER_ORDERS_ERROR")<undefined, SupplierOrders, Error>()


export const getSupplierOrdersAsyncThunk = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getSupplierOrdersAsync.request())
            webApiGet('/supplysystem/orders',
                (data: SupplierOrders) => { dispatch(getSupplierOrdersAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getSupplierOrdersAsync.failure(err)); },
                null, 3
            )
        })
    }
}

export const updatePrices = createAction("UPDATE_PRICES")<SupplierProductMapping>()